// extracted by mini-css-extract-plugin
module.exports = {"StudiesModuleSubjectForm":"style_StudiesModuleSubjectForm__1fzdx","titleWrapper":"style_titleWrapper___EfGT","contentWrapper":"style_contentWrapper__2fx2y"};